<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />
<script src="https://cdn.jsdelivr.net/npm/quill@2.0.2/dist/quill.js"></script>
<link href="https://cdn.jsdelivr.net/npm/quill@2.0.2/dist/quill.snow.css" rel="stylesheet" />
<app-config class="hidden" />

<ng-container *ngIf="isLoading(); else contentLoaded">
  <div class="bg-surface dark:bg-surface-950">
    <div class="flex">
      <div class="m-4 text-red-500 text-2xl">Loading page...</div>
      <div class="my-4 spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #contentLoaded>
  <div class="flex flex-wrap gap-4 p-4">
    <!-- Note 1 -->
    <div class="flex-1 min-w-[300px] basis-[calc(50%-0.5rem)] bg-white border border-green-300 p-4">
      <div class="block z-50 bg-green-200">
        <div class="m-1 text-xl border text-black">
          <div class="flex align-top">
            <p-menu
              class="page-menu"
              [model]="menuItems"
              #menu1
              [popup]="true"
              [style]="{
                marginTop: '40px',
                leftMargin: '10px',
                backgroundColor: '#ffffff',
                color: 'black',
                borderRadius: '8px',
                border: '1px solid #000000',
                padding: '10px',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                appendTo: 'body'
              }" />
            <p-button (click)="menu1.toggle($event)" class="mx-2" icon="pi pi-bars" />

            <span class="flex items-center !w-full justify-end gap-4 ml-auto">
              <span
                class="p-1 bold !w-full !text-primary-800 dark:text-primary-contrast !print:text-black"
                *ngIf="localNote">
                Local:
                {{ localNote.Title || ' ' }}
              </span>
              <p-button
                text
                class="p-0 m-0 border-0 shadow-none bg-transparent text-primary !print:hidden"
                (click)="pageMenu('Close')">
                <ng-template pTemplate="icon">
                  <i class="pi pi-times-circle !text-[30px] !text-primary-800"></i>
                </ng-template>
              </p-button>
            </span>
          </div>
        </div>
      </div>

      <div>
        <div *ngIf="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>

        <!-- Meta-Data Pane (visibility can be toggled) -->
        <div class="mt-2 bg-primary-50 text-[var(--textColor)]" id="localNoteContent">
          <div class="m-0 p-0" *ngIf="isHeaderVisible">
            <div class="flex w-full m-0 items-center">
              <div class="flex p-1 h-10 w-1/2 gap-3">
                <div class="w-32 bold left-0 p-1 text-primary">ID</div>
                <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                  {{ localNote._id }}
                </div>
              </div>
              <div class="flex p-1 h-10 w-1/2 gap-3">
                <div class="w-32 bold left-0 p-1 text-primary">Status</div>
                <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                  {{ localNote.Status }}
                </div>
              </div>
            </div>

            <div class="flex w-full m-0 items-center">
              <div class="flex p-1 h-10 w-1/2 gap-3">
                <div class="w-32 bold left-0 p-1 text-primary whitespace-nowrap">Sync-Time</div>
                <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                  {{ localNote.syncTime | date : 'dd.MMM.yyyy HH:mm' }}
                </div>
              </div>
              <div class="flex p-1 h-10 w-1/2 gap-3">
                <div class="w-32 bold left-0 p-1 text-primary whitespace-nowrap">Sync-Status</div>
                <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                  {{ localNote.syncStatus }}
                </div>
              </div>
            </div>

            <div class="flex w-full m-0 items-center">
              <div class="flex p-1 h-10 w-1/2 gap-3">
                <div class="w-32 bold left-0 p-1 text-primary">Created</div>
                <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                  {{ localNote.created_on | date : 'dd.MMM.yyyy HH:mm' }}
                </div>
              </div>
              <div class="flex p-1 h-10 w-1/2 gap-3">
                <div class="w-32 bold left-0 p-1 text-primary">Modified</div>
                <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                  {{ localNote.last_modified | date : 'dd.MMM.yyyy HH:mm' }}
                </div>
              </div>
            </div>

            <div class="flex w-full m-0 items-center">
              <div class="flex p-1 h-10 w-full gap-3">
                <div class="w-32 bold flex p-1 text-primary">Project</div>
                <div
                  class="w-full p-1 border border-[var(--borderColor)] bg-surface-0 text-surface-700 dark:text-surface-100"
                  id="Project">
                  {{ localNote.ProjectName }}
                </div>
              </div>
            </div>
            <div class="flex w-full m-0 items-center">
              <div class="flex p-1 h-10 w-full gap-3">
                <div class="w-32 bold flex p-1 text-primary">Categories</div>
                <div
                  class="w-full p-1 border border-[var(--borderColor)] bg-surface-0 text-surface-700 dark:text-surface-100"
                  id="Project">
                  {{ CategoriesString }}
                </div>
              </div>
            </div>
            <div class="flex w-full m-0 items-center">
              <div class="flex p-1 h-10 w-full gap-3">
                <div class="w-32 bold flex p-1 text-primary">Type</div>
                <div
                  class="w-full p-1 border border-[var(--borderColor)] bg-surface-0 text-surface-700 dark:text-surface-100"
                  id="NoteType">
                  {{ localNote.NoteType }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Description Lablel + Button to toggle the header fields -->
        <div class="row" style="display: flex; align-items: left; justify-content: space-between">
          <div class="w-32 bold flex text-primary p-1">Description</div>
          <button
            type="button"
            class="text-primary w-24 border border-primary mr-2 print:hidden"
            (click)="toggleHeaderFields()"
            [title]="isHeaderVisible ? 'Hide header fields' : 'Show header fields'">
            <ng-container *ngIf="isHeaderVisible">
              <i class="fas fa-angle-double-up"></i>
            </ng-container>
            <ng-container *ngIf="!isHeaderVisible">
              <i class="fas fa-angle-double-down !text-primary-800"></i>
            </ng-container>
          </button>
        </div>

        <app-rich-editor editorId="local-conflict-description" [delta]="localNote.DescriptionDelta" [readOnly]="true" [placeholderText]="''"> </app-rich-editor>
        <div class="flex w-full gap-3">
          <div class="bold left-0 p-1 text-primary">File Attachments</div>
        </div>
        <div class="block w-full m-0 items-center mb-4">
          <app-file-upload [noteId]="localNote._id" [readOnly]="true"> </app-file-upload>
        </div>
        <div class="flex w-full m-0 items-center">
          <div class="flex p-1 h-10 w-full gap-3">
            <div class="w-32 bold flex text-primary p-1">Keywords</div>
            <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100" id="Keywords">
              {{ localNote.Keywords }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="w-32 bold flex p-1 text-primary">Comments</div>
        </div>
        <app-rich-editor editorId="local-conflict-comments" [delta]="localNote.CommentsDelta" [readOnly]="true" [placeholderText]="''"> </app-rich-editor>
      </div>
    </div>

    <!-- RIGHT-HAND RECORD - COUCHDB -->

    <div class="flex-1 min-w-[300px] basis-[calc(50%-0.5rem)] bg-white border border-red-300 p-4">
      <div class="bg-surface-200 dark:bg-surface-950">
        <div class="flex-row">
          <div id="printable-content">
            <!-- Large Screen App-Head pane -->
            <div class="block sticky top-0 z-50 bg-red-200">
              <div class="m-1 text-xl border text-black">
                <div class="flex align-top">
                  <p-menu
                    class="page-menu"
                    [model]="menuItems"
                    #menu
                    [popup]="true"
                    [style]="{
                      marginTop: '40px',
                      leftMargin: '10px',
                      backgroundColor: '#ffffff',
                      color: 'black',
                      borderRadius: '8px',
                      border: '1px solid #000000',
                      padding: '10px',
                      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                      appendTo: 'body'
                    }" />
                  <p-button (click)="menu.toggle($event)" class="mx-2" icon="pi pi-bars" />

                  <span class="flex items-center !w-full justify-end gap-4 ml-auto">
                    <span
                      class="p-1 bold !w-full !text-primary-800 dark:text-primary-contrast !print:text-black"
                      *ngIf="remoteNote">
                      Remote:
                      {{
                        remoteNote.Title ||
                          '
                                    '
                      }}</span
                    >
                    <p-button
                      text
                      class="p-0 m-0 border-0 shadow-none bg-transparent text-primary !print:hidden"
                      (click)="pageMenu('Close')">
                      <ng-template pTemplate="icon">
                        <i class="pi pi-times-circle !text-[30px] !text-primary-800"></i>
                      </ng-template>
                    </p-button>
                  </span>
                </div>
              </div>
            </div>

            <div>
              <div *ngIf="errorMessage" class="error-message">
                {{ errorMessage }}
              </div>

              <!-- Meta-Data Pane (visibility can be toggled) -->
              <div class="mt-2 bg-primary-50 text-[var(--textColor)]" id="remoteNoteContent">
                <div class="m-0 p-0" *ngIf="isHeaderVisible">
                  <div class="flex w-full m-0 items-center">
                    <div class="flex p-1 h-10 w-1/2 gap-3">
                      <div class="w-32 bold left-0 p-1 text-primary">ID</div>
                      <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                        {{ remoteNote._id }}
                      </div>
                    </div>
                    <div class="flex p-1 h-10 w-1/2 gap-3">
                      <div class="w-32 bold left-0 p-1 text-primary">Status</div>
                      <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                        {{ remoteNote.Status }}
                      </div>
                    </div>
                  </div>

                  <div class="flex w-full m-0 items-center">
                    <div class="flex p-1 h-10 w-1/2 gap-3">
                      <div class="w-32 bold left-0 p-1 text-primary whitespace-nowrap">Sync-Time</div>
                      <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                        {{ remoteNote.syncTime | date : 'dd.MMM.yyyy HH:mm' }}
                      </div>
                    </div>
                    <div class="flex p-1 h-10 w-1/2 gap-3">
                      <div class="w-32 bold left-0 p-1 text-primary whitespace-nowrap">Sync-Status</div>
                      <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                        {{ remoteNote.syncStatus }}
                      </div>
                    </div>
                  </div>

                  <div class="flex w-full m-0 items-center">
                    <div class="flex p-1 h-10 w-1/2 gap-3">
                      <div class="w-32 bold left-0 p-1 text-primary">Created</div>
                      <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                        {{ remoteNote.created_on | date : 'dd.MMM.yyyy HH:mm' }}
                      </div>
                    </div>
                    <div class="flex p-1 h-10 w-1/2 gap-3">
                      <div class="w-32 bold left-0 p-1 text-primary">Modified</div>
                      <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100">
                        {{ remoteNote.last_modified | date : 'dd.MMM.yyyy HH:mm' }}
                      </div>
                    </div>
                  </div>

                  <div class="flex w-full m-0 items-center">
                    <div class="flex p-1 h-10 w-full gap-3">
                      <div class="w-32 bold flex p-1 text-primary">Project</div>
                      <div
                        class="w-full p-1 border border-[var(--borderColor)] bg-surface-0 text-surface-700 dark:text-surface-100"
                        id="Project">
                        {{ remoteNote.ProjectName }}
                      </div>
                    </div>
                  </div>
                  <div class="flex w-full m-0 items-center">
                    <div class="flex p-1 h-10 w-full gap-3">
                      <div class="w-32 bold flex p-1 text-primary">Categories</div>
                      <div
                        class="w-full p-1 border border-[var(--borderColor)] bg-surface-0 text-surface-700 dark:text-surface-100"
                        id="Project">
                        {{ CategoriesString }}
                      </div>
                    </div>
                  </div>
                  <div class="flex w-full m-0 items-center">
                    <div class="flex p-1 h-10 w-full gap-3">
                      <div class="w-32 bold flex p-1 text-primary">Type</div>
                      <div
                        class="w-full p-1 border border-[var(--borderColor)] bg-surface-0 text-surface-700 dark:text-surface-100"
                        id="NoteType">
                        {{ remoteNote.NoteType }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Description Lablel + Button to toggle the header fields -->
              <div class="row" style="display: flex; align-items: left; justify-content: space-between">
                <div class="w-32 bold flex text-primary p-1">Description</div>
                <button
                  type="button"
                  class="text-primary w-24 border border-primary mr-2 print:hidden"
                  (click)="toggleHeaderFields()"
                  [title]="isHeaderVisible ? 'Hide header fields' : 'Show header fields'">
                  <ng-container *ngIf="isHeaderVisible">
                    <i class="fas fa-angle-double-up"></i>
                  </ng-container>
                  <ng-container *ngIf="!isHeaderVisible">
                    <i class="fas fa-angle-double-down !text-primary-800"></i>
                  </ng-container>
                </button>
              </div>

              <app-rich-editor editorId="remote-conflict-description" [delta]="remoteNote.DescriptionDelta" [readOnly]="true" [placeholderText]="''"> </app-rich-editor>
              <div class="flex w-full gap-3">
                <div class="bold left-0 p-1 text-primary">File Attachments</div>
              </div>
              <div class="block w-full m-0 items-center mb-4">
                <app-file-upload [noteId]="remoteNote._id" [readOnly]="true"> </app-file-upload>
              </div>
              <div class="flex w-full m-0 items-center">
                <div class="flex p-1 h-10 w-full gap-3">
                  <div class="w-32 bold flex text-primary p-1">Keywords</div>
                  <div class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100" id="Keywords">
                    {{ remoteNote.Keywords }}
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="w-32 bold flex p-1 text-primary">Comments</div>
              </div>
              <app-rich-editor editorId="remote-conflict-comments" [delta]="remoteNote.CommentsDelta" [readOnly]="true" [placeholderText]="''"> </app-rich-editor>
            </div>

            <!-- FOOTER BAR -->
            <div
              class="fixed bottom-0 inset-x-0 flex items-center justify-between border-t bg-surface-0 text-xl p-1 z-[var(--z-toolbar)]">
              <div class="flex gap-2">
                <button pButton class="!bg-green-200" (click)="resolveConflict('local')" label="Keep Local"></button>
                <button pButton class="!bg-red-200" (click)="resolveConflict('remote')" label="Keep CouchDB"></button>
                <button pButton icon="pi pi-search-plus" (click)="overlay?.toggle($event)"></button>

                <!-- ✅ Popover positioned above the button -->
                <p-popover
                  #overlay
                  [dismissable]="true"
                  appendTo="body"
                  position="top"
                  class="z-overlay translate-y-[-5rem]">
                  <div class="p-1 w-56 flex flex-col gap-2">
                    <label class="text-sm font-semibold">Editor Zoom</label>
                    <p-slider
                      [(ngModel)]="editorZoomFactor"
                      [min]="50"
                      [max]="400"
                      [step]="1"
                      (onChange)="onZoomFactorChange('editor', editorZoomFactor)"
                      (onSlideEnd)="persistEditorZoom()">
                    </p-slider>
                    <div class="text-center text-sm">{{ editorZoomFactor }}%</div>
                  </div>
                </p-popover>
              </div>

              <div class="text-sm">Status message</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
